var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-bar",on:{"click":_vm.tipClick}},[_vm._m(0),_c('div',{ref:"wrap",staticClass:"notice-bar__wrap"},[_c('div',{ref:"content",staticClass:"notice-bar__content",style:(_vm.contentStyle)},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-bar__icon"},[_c('img',{attrs:{"src":require("@/assets/home/tip.png")}})])
}]

export { render, staticRenderFns }